import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import { extractPropInfo } from "../../MyDLD/PropertyDetails";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import PropertyPhotos from "../Component/PropertyPhoto";
import { BuyerInfo, PSDocument, PvtSellRequest, RemoteDocument, Terms, } from "../../../apis/privatesell/enitites";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import CheckBoxField from "@eres/forms-web/CheckBoxField";
import { showTerms } from "../../../apis/privatesell/api";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import BookingDetails from "../Component/BookingDetails";
import BankDetails from "../Component/BankDetails";
import BuyerInfoDetail from "../Component/BuyerInfo";
import SellerDescription from "../Component/SellerDescription";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { Redirect } from "react-router";
import PrivateSell from "../index";
import { privateSellApi, privateSellService } from "../../../apis/privatesell";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import SellerSuccessPopup from "./SellerSuccessPopup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { normalizeRemoteDocToPSDocument } from "../../../apis/privatesell/services";

interface State {
	documents: PSDocument[];
	isLoading: boolean;
	isAgreed: boolean;
	formValid: boolean;
	property: AssetCard;
	request?: PvtSellRequest;
	applicationRef?: string;
	listOption?: Terms[];
}

class SellerRequestForm extends Component<RoutedViewProps, State> {
	propertyPhotosForm: PropertyPhotos | null | undefined;
	sellerDescriptionForm: SellerDescription | null | undefined;
	bookingDetailsForm: BookingDetails | null | undefined;
	bankDetailsForm: BankDetails | null | undefined;
	buyerInfoDetailForm: BuyerInfoDetail | null | undefined;

	constructor( props: RoutedViewProps ) {
		super( props );
		const request: PvtSellRequest | undefined = props.location.state ? props.location.state.request : undefined;
		this.state = {
			isLoading: false,
			isAgreed: false,
			formValid: true,
			listOption: props.location.state ? props.location.state.listOption : undefined,
			property: props.location.state ? props.location.state.property : undefined,
			request: request,
			documents: request && request.sellRequestInfo.documents ? normalizeRemoteDocToPSDocument( request.sellRequestInfo.documents ) : [],
		};
	}

	render() {
		const { documents, property, request, listOption } = this.state;
		const sellRequestInfo = request && request?.sellRequestInfo ? request?.sellRequestInfo : undefined;
		let description;
		let askingPrice;
		let transactionDuration;
		let bankDetail;
		const buyerInfo = request && request.bookingRequestInfo ? request.bookingRequestInfo.buyerInfo : undefined;
		if ( sellRequestInfo ) {
			description = sellRequestInfo.description;
			askingPrice = sellRequestInfo.askingPrice;
			transactionDuration = sellRequestInfo.transactionDuration;
			bankDetail = sellRequestInfo.bankAccount;
		}
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const formProps = {
			readonly: false,
			onUpdated: this.onFormValidityChanged,
			onFormLoad: this.onFormLoad,
		};
		const { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ Strings.sell_property } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ Strings.sell_property } paths={ [ DashboardBCItem ] }/>
			<PropertyPhotos { ...formProps } ref={ ( ref ) => this.propertyPhotosForm = ref }
			                documents={ documents }/>
			<SellerDescription { ...formProps } ref={ ( ref ) => this.sellerDescriptionForm = ref } description={ description }/>
			<BookingDetails { ...formProps } ref={ ( ref ) => this.bookingDetailsForm = ref } askingPrice={ askingPrice }
			                transactionDuration={ transactionDuration }
			                listOption={ listOption }/>
			<BankDetails { ...formProps } ref={ ( ref ) => this.bankDetailsForm = ref } bankDetail={ bankDetail }/>
			<BuyerInfoDetail { ...formProps } ref={ ( ref ) => this.buyerInfoDetailForm = ref } buyerInfo={ buyerInfo }>
				<div className="d-flex pb-2">
					<CheckBoxField
						errorManager={ defaultErrorManager }
						holder={ StateHolder.buildStateHolder( this ) }
						id={ "isAgreed" }
						label={ Strings.i_agree_to_the }
						/>
					<a className="btn-link ms-1" onClick={ this.onShowTerms }>{ Strings.terms_and_conditions }</a>
				</div>
			</BuyerInfoDetail>
			<div>
				<button onClick={ this.onValidate } className="btn btn_1 btn_style1" type="submit">
					{ Strings.submit_label }
				</button>
				<a onClick={ this.backToPage } className="btn btn-grey btn_style1 ms-2 me-2">{ Strings.close_label }</a>
			</div>
			<SellerSuccessPopup
				applicationRef={ this.state.applicationRef } isCancel={ false } property={ this.state.property }
				onDismiss={ this.onSuccessDismiss }/>
		</PageContent>;
	}

	onValidate = () => {
		let isValid = true;
		isValid = isValid && this.sellerDescriptionForm != null && this.sellerDescriptionForm.isValid();
		isValid = isValid && this.bookingDetailsForm != null && this.bookingDetailsForm.isValid();
		isValid = isValid && this.bankDetailsForm != null && this.bankDetailsForm.isValid();
		isValid = isValid && this.buyerInfoDetailForm != null && this.buyerInfoDetailForm.isValid();
		if ( isValid ) {
			if ( this.state.isAgreed ) {
				this.submitRequest();
			} else {
				showMessage( Strings.tc_error_msg );
			}
		}
	};

	backToPage = () => {
		this.props.history.goBack();
	};

	//region Generic FormCallbacks
	onFormValidityChanged = ( isValid: boolean, _data?: any ) => {
		this.setState( {
			formValid: isValid,
		} );
	};

	onFormValidityTermChanged = ( isValid: boolean, data?: BuyerInfo ) => {
		this.setState( {
			formValid: isValid,
		}, () => {
		} );
	};

	onFormLoad = ( isLoading: boolean ) => {
		this.setState( { isLoading: isLoading } );
	};

	private onSuccessDismiss = () => {
		JQModal( "SellerSuccessPopup" ).hide();
		this.props.history.goBack();
	};

	private submitRequest() {
		const { property, request } = this.state;
		const p = TabuProfile.getProfile();
		if ( p ) {
			const buyerInfo: Partial<BuyerInfo> | undefined = this.buyerInfoDetailForm?.getData();
			showLoading();
			privateSellService.uploadDocs( this.propertyPhotosForm?.getData().documents! ).then( ( docs: RemoteDocument[] ) => {
				let api = privateSellApi.createSellRequest;
				let bookingDetails = this.bookingDetailsForm?.getData();
				let agreements: Terms[] = request && request.termsAndConditions ? request.termsAndConditions : [];
				if ( bookingDetails && bookingDetails.selectedListingOptions ) {
					agreements.push( ...bookingDetails.selectedListingOptions );
				}
				let requestNew: Partial<PvtSellRequest> = {
					id: request ? request.id : undefined,
					transactionType: 1,
					sellRequestInfo: {
						...this.sellerDescriptionForm?.getData(),
						...bookingDetails,
						documents: docs,
						bankAccount: this.bankDetailsForm?.getData(),
						sellerDetails: {
							sellerId: request && request.sellRequestInfo.sellerDetails?.sellerId ? request.sellRequestInfo.sellerDetails?.sellerId : undefined,
							name: {
								arabicName: p.nameAr,
								englishName: p.nameEn,
							},
							participantId: p.tabuParticipantId!,
							mobile: p.phoneNumber!,
							email: p.emailAddress!,
						}
					},
					propertyInfo: {
						propertyId: property.tabuPropertyId,
						propertyType: property.propertyTypeId,
						ownerParticipantId: p.tabuParticipantId!,
						propertyObject: JSON.stringify( property ),
					},
					bookingRequestInfo: {
						...request && request.bookingRequestInfo ? request.bookingRequestInfo : undefined,
						buyerInfo: buyerInfo,
					},
					termsAndConditions: agreements,
				};
				if ( request ) {
					api = privateSellApi.updateSellRequest;
				}
				api( requestNew as PvtSellRequest ).then( response => {
					hideLoading();
					if ( response ) {
						if ( response.request && response.request.bookingRequestInfo && response.request.bookingRequestInfo.referenceNumber ) {
							trackEventWithData( "PrivateSell", request ? "SellRequestReviewed" : "SellRequestCreate", { propertyID: requestNew.propertyInfo?.propertyId } );
							JQModal( "SellerSuccessPopup" ).show();
							this.setState( { applicationRef: response.request.bookingRequestInfo.referenceNumber } );
						}
					}
				} ).catch( exp => {
					hideLoading();
					showMessage( exp.message );
				} );
			} ).catch( exp => {
				hideLoading();
				showMessage( exp.message );
			} );
		}

	}

	private onShowTerms = () => {
		// this.setState({ showTerms: true });
		this.setState( {
			isAgreed: true,
		}, showTerms );
	};
}

export default SellerRequestForm;
